import VTooltip from 'v-tooltip';
import Vue from 'vue';

Vue.use(VTooltip, {
  defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click',
  defaultHtml: true,
  defaultAllowHtml: true,
});
